module.exports = __webpack_public_path__ + "img/Kc.bd067c33.png";